import {
    createFeatureSelector,
    createSelector
} from '@ngrx/store';
import {
    DATIQAPP_FEATURE_KEY,
    DatiqAppPartialState,
    State,
} from './datiq-app.reducer';
import {
    DatiqAppConfig,
    DatiqEnvironments,
    IDatiqRoute,
    IDatiqRulesData,
    IDatiqUnavItem,
} from '@dat/datiq-core/models';

// Lookup the 'DatiqApp' feature state managed by NgRx
export const getDatiqAppState = createFeatureSelector<
    DatiqAppPartialState,
    State
>(DATIQAPP_FEATURE_KEY);

export const getDatiqAppLoaded = createSelector(
    getDatiqAppState,
    (state: State) => state?.loaded
);
export const getDatiqAppConfig = () =>
    createSelector(getDatiqAppState, (state: State) => state?.config);

export const isEnvironment = (environment: DatiqEnvironments) =>
    createSelector(
        getDatiqAppConfig(),
        (config: DatiqAppConfig): boolean => config?.environment === environment
    );
export const getEnvironment = () =>
    createSelector(
        getDatiqAppConfig(),
        (config: DatiqAppConfig): string => config?.environment
    );
export const getLinkRules = () =>
    createSelector(
        getDatiqAppConfig(),
        (config: DatiqAppConfig): IDatiqRulesData<IDatiqUnavItem>[] =>
            config?.links || []
    );
export const getUserLinkRules = () =>
    createSelector(
        getDatiqAppConfig(),
        (config: DatiqAppConfig): IDatiqRulesData<IDatiqUnavItem>[] =>
            config?.userLinks || []
    );
export const getCurrentRoute = () =>
    createSelector(
        getDatiqAppConfig(),
        (config: DatiqAppConfig): IDatiqRoute =>
            config?.currentRoute || { path: '', params: {} }
    );
export const isCurrentRoute = (path: string) =>
    createSelector(
        getCurrentRoute(),
        (route: IDatiqRoute): boolean => route.path === path
    );
export const containsCurrentRoute = (path: string) =>
    createSelector(
        getCurrentRoute(),
        (route: IDatiqRoute): boolean => route.path.indexOf(path) >= 0
    );
export const isCurrentRouteUnlocked = () =>
    createSelector(
        getCurrentRoute(),
        (route: IDatiqRoute): boolean => !route.locked
    );
